export const Tests = {
    AdvancedFiltersTitle: 'Tests',
};
